'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('../../language/translate');

var _LabelledInputComponent = require('../../components/input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a Recurring Payments Input Fields component along with a corresponding labels.
 */
var RecurringPaymentsComponent = function (_React$Component) {
  _inherits(RecurringPaymentsComponent, _React$Component);

  function RecurringPaymentsComponent() {
    _classCallCheck(this, RecurringPaymentsComponent);

    return _possibleConstructorReturn(this, (RecurringPaymentsComponent.__proto__ || Object.getPrototypeOf(RecurringPaymentsComponent)).apply(this, arguments));
  }

  _createClass(RecurringPaymentsComponent, [{
    key: 'render',
    value: function render() {
      return this.props.fields.payment.payment_option.value === 'monthly' ? _react2.default.createElement(
        'div',
        { className: 'recurring-payment-box' },
        _react2.default.createElement(
          'h4',
          null,
          _react2.default.createElement(
            'u',
            null,
            (0, _translate.t)('Payment Schedule')
          )
        ),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputLabel: (0, _translate.t)('Policy Issue Fee'),
          inputComponent: _reactBootstrap.FormControl.Static,
          inputComponentChildren: this.props.application.quote.policy_fee,
          isStatic: true
        }),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'totalInitialPayment',
          inputLabel: (0, _translate.t)('Total Initial Payment'),
          inputComponent: _reactBootstrap.FormControl.Static,
          inputComponentChildren: this.props.application.quote.first_payment,
          isStatic: true
        }),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputLabel: (0, _translate.t)('10 Monthly Payments of'),
          inputComponent: _reactBootstrap.FormControl.Static,
          inputComponentChildren: this.props.application.quote.monthly_payment,
          isStatic: true
        }),
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputLabel: (0, _translate.t)('Total Premium'),
          inputComponent: _reactBootstrap.FormControl.Static,
          inputComponentChildren: this.props.application.quote.total_for_recurring_payments,
          isStatic: true
        })
      ) : null;
    }
  }]);

  return RecurringPaymentsComponent;
}(_react2.default.Component);

RecurringPaymentsComponent.propTypes = {
  application: _react2.default.PropTypes.object,
  fields: _react2.default.PropTypes.object
};
exports.default = RecurringPaymentsComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/RecurringPaymentsComponent.jsx
// module id = 809
// module chunks = 0